import { Reducer } from 'redux';
import ActionTypes, { TFinalTestState } from './types';

export const initialState: TFinalTestState = {
  error: null,
  loading: false,
  data: null,
};

const reducer: Reducer<TFinalTestState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_FINAL_TEST_R:
      return { ...state, loading: true, error: null };
    case ActionTypes.SEND_FINAL_TEST_S:
    case ActionTypes.GET_FINAL_TEST_S:
      return { ...state, data: action.payload, loading: false, error: null };
    case ActionTypes.GET_FINAL_TEST_E:
    case ActionTypes.SEND_FINAL_TEST_E:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};

export { reducer as FinalTestReducer };
